<template>
  <div class='publicCounpon' v-if="couponList.length">
    <div class="couponDialog">
      <!-- 标题 -->
      <div class="totalTitle">
        恭喜您获得<span>{{total}}</span>张优惠券
      </div>
      <!-- 列表 -->
      <div class="couponList">
        <div class="couponItem" v-for="(item,index) in couponList" :key="index">
          <div class="item_left">
            <div class="price"><span>￥</span>{{item.money}}</div>
            <div class="full_name">
              {{item.full_name}}
            </div>
          </div>
          <div class="item_center">
            <div class="userRange">
              {{item.use_range}}
            </div>
            <div class="expireTime">
              有效期至：{{item.expire_at}}
            </div>
          </div>
          <div class="item_right">
            <div class="btn" @click="gotoDetail(item.user_coupon_id)">
              立即查看
            </div>
          </div>
          <!-- 右上角张数 -->
          <div class="totalNum">
            {{item.total}}张
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btnWrap">
        <div class="gotoLook" @click=gotoCouponList()>
          立即查看
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  // props: ['couponList'],
  components: {},
  data () {
    return {
      total: '',
      couponList: [
        // {
        //   "id": "5",
        //   "money": 5,
        //   "name": "5元优惠券",
        //   "is_full_decrement": "1",
        //   "full_decrement_money": 100,
        //   "is_all": "1",
        //   "expire_at": "2020.06.04",
        //   "full_name": "满100可用",
        //   "total": 1,
        //   "use_range": "特卖"
        // },
        // {
        //   "id": "5",
        //   "money": 5,
        //   "name": "5元优惠券",
        //   "is_full_decrement": "1",
        //   "full_decrement_money": 100,
        //   "is_all": "1",
        //   "expire_at": "2020.06.04",
        //   "full_name": "满100可用",
        //   "total": 1,
        //   "use_range": "特卖"
        // },
        // {
        //   "id": "5",
        //   "money": 5,
        //   "name": "5元优惠券",
        //   "is_full_decrement": "1",
        //   "full_decrement_money": 100,
        //   "is_all": "1",
        //   "expire_at": "2020.06.04",
        //   "full_name": "满100可用",
        //   "total": 1,
        //   "use_range": "特卖"
        // },
        // {
        //   "id": "5",
        //   "money": 5,
        //   "name": "5元优惠券",
        //   "is_full_decrement": "1",
        //   "full_decrement_money": 100,
        //   "is_all": "1",
        //   "expire_at": "2020.06.04",
        //   "full_name": "满100可用",
        //   "total": 1,
        //   "use_range": "特卖"
        // },
        // {
        //   "id": "5",
        //   "money": 5,
        //   "name": "5元优惠券",
        //   "is_full_decrement": "1",
        //   "full_decrement_money": 100,
        //   "is_all": "1",
        //   "expire_at": "2020.06.04",
        //   "full_name": "满100可用",
        //   "total": 1,
        //   "use_range": "特卖"
        // },
        // {
        //   "id": "5",
        //   "money": 5,
        //   "name": "5元优惠券",
        //   "is_full_decrement": "1",
        //   "full_decrement_money": 100,
        //   "is_all": "1",
        //   "expire_at": "2020.06.04",
        //   "full_name": "满100可用",
        //   "total": 1,
        //   "use_range": "特卖"
        // },
        // {
        //   "id": "5",
        //   "money": 5,
        //   "name": "5元优惠券",
        //   "is_full_decrement": "1",
        //   "full_decrement_money": 100,
        //   "is_all": "1",
        //   "expire_at": "2020.06.04",
        //   "full_name": "满100可用",
        //   "total": 1,
        //   "use_range": "特卖"
        // },
        // {
        //   "id": "3",
        //   "money": 15,
        //   "name": "15元优惠券",
        //   "is_full_decrement": "0",
        //   "full_decrement_money": 0,
        //   "is_all": "1",
        //   "expire_at": "2020.08.01",
        //   "full_name": "",
        //   "total": 2,
        //   "use_range": "乒乓球"
        // },
        // {
        //   "id": "1",
        //   "money": 10,
        //   "name": "10元优惠券",
        //   "is_full_decrement": "1",
        //   "full_decrement_money": 300,
        //   "is_all": "1",
        //   "expire_at": "2010.12.01",
        //   "full_name": "满300可用",
        //   "total": 1,
        //   "use_range": "乒乓球、羽毛球、篮球、台球"
        // }
      ],
      vip_id: '',
      token: ''
    }
  },
  created () {
    this.getToken()
    this.vip_id = this.$route.query.id
    this.getCounponList()
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token);
    },
    // 获取购买成功后获得的优惠券
    async getCounponList () {
      let params = {
        token: this.token,
        vip_id: this.vip_id,
        statistics: this.$CONFIG.statistics
      }
      // console.log(params,this.$vipapi);
      let res = await this.$vipapi.getCounponList(params)
      // 此处上线时需要放开，目前没数据，注释掉写样式
      this.couponList = res.data.data.data
      this.total = res.data.data.total
      if (this.couponList) {
        let params = {
          token: this.token,
          vip_id: this.vip_id,
        }
        let res2 = await this.$vipapi.couponConfirm(params)
        if (res2.data.status == 200) {
          console.log("优惠券已领取成功")
        } else {
          console.log(res)
        }

      }
      console.log(this.couponList);
    },
    // 跳转优惠券详情
    gotoDetail (id) {
      // window.location.href = `${this.$ADDRESS.address3}/h5conpons/#/detail/${id}?token=${this.token}`
      let url = `${this.$ADDRESS.address3}/h5conpons/#/detail/${id}?token=${this.token}`
      var androidParam = '{"url":"' + url + '"}';
      var iosParam = {
        "url": url
      };
      try {
        window.webkit.messageHandlers.jumpWeb.postMessage(iosParam);
      } catch (e) {
        console.log('ios打开新页面失败');
      }

      try {
        window.LiveAppJS.jumpWeb(androidParam);
      } catch (e) {
        console.log('安卓打开新页面失败');
      }
    },
    // 跳转优惠券列表
    gotoCouponList () {
      // window.location.href = `${this.$ADDRESS.address3}/h5conpons/#/list/?token=${this.token}`
      let url = `${this.$ADDRESS.address3}/h5conpons/#/list/?token=${this.token}`
      var androidParam = '{"url":"' + url + '"}';
      var iosParam = {
        "url": url
      };
      try {
        window.webkit.messageHandlers.jumpWeb.postMessage(iosParam);
      } catch (e) {
        console.log('ios打开新页面失败');
      }

      try {
        window.LiveAppJS.jumpWeb(androidParam);
      } catch (e) {
        console.log('安卓打开新页面失败');
      }
    }
  },
}
</script>
<style lang='less' scoped>
.publicCounpon {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  .couponDialog {
    width: 6rem;
    height: 7.6rem;
    padding: 0.4rem 0.15rem 0rem 0.15rem;
    overflow: hidden;
    // box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.08rem;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    flex-direction: column;

    // 标题
    .totalTitle {
      height: 0.5rem;
      margin-bottom: 0.3rem;
      text-align: center;
      font-size: 0.36rem;
      line-height: 0.5rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      span {
        color: #ff553b;
      }
    }
    // 列表
    .couponList {
      width: 100%;
      height: 5.4rem;
      // flex-shrink: 0;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .couponItem {
        width: 100%;
        padding: 0.5rem 0.35rem;
        box-sizing: border-box;
        height: 1.9rem;
        background: #ffffff;
        background: url('https://images.zhibo.tv/2020/0605/coupons.svg')
          no-repeat center center;
        background-size: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .item_left {
          width: 1.3rem;
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-right: 0.1rem;
          .price {
            span {
              font-size: 0.3rem;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #ff5e3f;
            }
            font-size: 0.8rem;
            font-family: BebasNeue;
            color: #ff5e3f;

            line-height: 0.5rem;
          }
          .full_name {
            font-size: 0.16rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff5e3f;
          }
        }
        .item_center {
          flex: 1;
          display: flex;
          flex-direction: column;
          .userRange {
            margin-bottom: 0.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;

            font-size: 0.22rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
          .expireTime {
            white-space: nowrap;
            font-size: 0.22rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
        .item_right {
          margin-left: 0.2rem;
          display: flex;
          justify-content: center;
          .btn {
            width: 1.2rem;
            height: 0.44rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(135deg, #ff6945 0%, #ff4834 100%);
            border-radius: 0.22rem;

            font-size: 0.24rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            text-align: center;
          }
        }
        .totalNum {
          width: 1.25rem;
          height: 0.4rem;
          border-radius: 0 0 0 0.05rem;
          position: absolute;
          top: 0.08rem;
          right: 0.11rem;
          background: url('https://images.zhibo.tv/2020/0618/conponbg@3x.png')
            no-repeat;
          background-size: 100%;
          text-align: center;
          font-size: 0.2rem;
          color: #e2d1be;
          line-height: 0.35rem;
        }
      }
    }
    // 按钮
    .btnWrap {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffff;
      // border-radius: 8px;
      .gotoLook {
        width: 5.2rem;
        height: 0.8rem;
        margin: 0 auto;
        border-radius: 0.5rem;
        background: linear-gradient(
          135deg,
          rgba(255, 105, 69, 1) 0%,
          rgba(255, 72, 52, 1) 100%
        );

        font-size: 0.32rem;
        line-height: 0.8rem;
        color: #fff;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
  }
}
</style>
